import MailStats from "@mail/stats-sdk";
import type { IBaseStatsConfig, IStatsConfig } from "@mail/stats-sdk";


interface IAttrs{
  [index:string]:any
}

interface IUTM{
  'utm_id':  string
  'utm_source':  string
  'utm_medium':  string
  'utm_term':  string
  'utm_content':  string
  'utm_campaign':  string
}

export default class Stats {
  private mailStats: MailStats;

  private attrs:IAttrs ={} 

  constructor(options: IBaseStatsConfig & { config: IStatsConfig }) {
    const { config, ...props } = options;
    this.mailStats = new MailStats({ ...props });
    this.mailStats.config(config);
  }
  private log(method: string, key: string, payload: any) {
    console.log('stats log: ', key );
    // @ts-ignore
    this.mailStats && this.mailStats[method](key, payload || {});
  }

  public setCommonData(key:string, value:any){
    this.attrs[key] =value
  }
  public setCommonDataByObj(obj:IAttrs){
    Object.keys(obj).forEach((key) => { 
      this.attrs[key] = obj[key];
     })
  }

  public getCommonData(){
    return this.attrs
  }

  public clearCommonData(targetKey:string){
    var newAttr:IAttrs = {};
    Object.keys(this.attrs).forEach((key) => { 
      if(targetKey === key){return}
      newAttr[key] = this.attrs[key];
     });
     this.attrs = newAttr
  }

  public clearAllCommonData(){
    this.attrs = {}
  }

  public getUTM(key?:keyof IUTM):IUTM |string {
    // @ts-ignore
    const UTM:IUTM = this.mailStats._getUtm();
    return UTM["utm_source"]
  }

  public pv(key: string, payload: any = {}) {
    payload = Object.assign(payload, this.getCommonData());
    this.log("pv", key, payload);
  }
  public click(key: string, payload: any= {}) {
    payload = Object.assign(payload, this.getCommonData());
    this.log("click", key, payload);
  }
  public show(key: string, payload: any = {}) {
    payload = Object.assign(payload, this.getCommonData());
    this.log("show", key, payload);
  }
  public setUid(uid: string) {
    this.mailStats && this.mailStats.setUid(uid);
  }
  public setMasterAccount(muid: string) {
    this.mailStats && this.mailStats.setMasterAccount(muid);
  }

  public hide(key: string, payload: any = {}) {
    payload = Object.assign(payload, this.getCommonData());
    this.log("hide", key, payload);
  }

  time(key: string, payload: any = {}) {
    payload = Object.assign(payload, this.getCommonData());
    this.log("time", key, payload);
  }

  performance(key: string, payload: any= {}) {
    payload = Object.assign(payload, this.getCommonData());
    this.log("performance", key, payload);
  }

  data(key: string, payload: any = {}) {
    payload = Object.assign(payload, this.getCommonData());
    this.log("data", key, payload);
  }
}
